import * as React from 'react';
import {CSSProperties} from 'react';

interface Props {
  value: string;
  style?: CSSProperties;
}

class Label extends React.Component<Props, {}> {

  public render(): React.ReactNode {
    const {value, style} = this.props;

    const textStyle: CSSProperties = {
      fontSize: 12,
      color: '#aaaaaa',
      marginLeft: 8,
      marginRight: 8,
      ...style,
    };

    return (
      <span style={textStyle}>{value}</span>
    );
  }
}

export default Label;


// WEBPACK FOOTER //
// ./src/common/Label.tsx